/**
 * Pure helper: should the resolved HandoffViewer render surface a
 * soft "view limit reached" notice above the PDF?
 *
 * Yes iff the server set `consumed: true` on the success payload,
 * which only happens when an SLP explicitly opted into a
 * FERPA-strict `max_views` cap AND this view is the one that
 * exceeded it. Normal multi-use within TTL always returns
 * `consumed: false`.
 *
 * Lives in its own module (rather than inline in
 * HandoffViewer.tsx) so the .tsx file can export only components
 * — that satisfies the `react/only-export-components` oxlint rule
 * the rest of web/src follows. Mirrored as a pure helper in
 * web/test/handoff.test.ts.
 */
export interface ResolvedHandoffPayload {
  consumed: boolean;
}

export function shouldShowConsumedNotice(
  data: ResolvedHandoffPayload,
): boolean {
  return data.consumed === true;
}
